/**
 * SSG Count-Up Animation
 * Shared animated counter for stats sections.
 * Add data-ssg-count-section to the container element.
 * Optionally set data-ssg-count-duration="2500" (ms, default 2000).
 * Counter elements must have data-count-target="800+" (the target value).
 */
(function () {
  function parse(str) {
    var m = str.match(/^([^0-9]*)([0-9][0-9,.]*)(.*)$/);
    if (!m) return null;
    var prefix = m[1];
    var numStr = m[2].replace(/,/g, '');
    var suffix = m[3];
    var num = parseFloat(numStr);
    var hasCommas = m[2].indexOf(',') !== -1;
    var decimals = numStr.indexOf('.') !== -1 ? numStr.split('.')[1].length : 0;
    if (isNaN(num)) return null;
    return { prefix: prefix, number: num, suffix: suffix, hasCommas: hasCommas, decimals: decimals };
  }

  function formatWithCommas(n) {
    var parts = n.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function easeOutExpo(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }

  function countUp(el, data, duration) {
    var start = null;

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = easeOutExpo(progress);
      var current = eased * data.number;

      if (data.decimals > 0) {
        current = current.toFixed(data.decimals);
      } else {
        current = Math.round(current);
      }

      var display = data.hasCommas ? formatWithCommas(current) : current;
      el.textContent = data.prefix + display + data.suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  function init() {
    if (!('IntersectionObserver' in window)) return;

    var sections = document.querySelectorAll('[data-ssg-count-section]');

    sections.forEach(function (section) {
      var els = section.querySelectorAll('[data-count-target]');
      if (!els.length) return;

      var duration = parseInt(section.getAttribute('data-ssg-count-duration')) || 2000;
      var animated = false;

      var observer = new IntersectionObserver(
        function (entries) {
          if (animated) return;
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              animated = true;
              els.forEach(function (el) {
                var data = parse(el.getAttribute('data-count-target'));
                if (data) {
                  el.textContent = data.prefix + '0' + data.suffix;
                  countUp(el, data, duration);
                }
              });
            }
          });
        },
        { threshold: 0.3 }
      );

      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
